import React from "react";
import PageSection from "./PageSection";

import { FaRocket, FaSatellite, FaRobot, FaMicrochip } from "react-icons/fa";

const Prodcuts = () => {
  const products = [
    {
      id: 1,
      icon: <FaRocket size={50} className="text-white" />,
      title: "rocket manufacturing",
      subtitle:
        "Vikram-I is one of a trio of rockets Skyroot is currently developing; the other two, Vikram-II and Vikram-III, will be able to carry heavier payloads with multiple orbital insertions, Skyroot says.",
    },
    {
      id: 2,
      icon: <FaMicrochip size={50} className="text-white" />,
      title: "advanced electronics",
      subtitle:
        "Web 3.0 is still evolving and being defined, and as such, there isn't a canonical, universally accepted definition. What is clear, though, is that Web 3.0 will have a strong emphasis on decentralized applications and make extensive use of blockchain-based technologies. Web 3.0 will also make use of machine learning and artificial intelligence (AI) to help empower more intelligent and adaptive applications.",
    },
    {
      id: 3,
      icon: <FaRobot size={50} className="text-white" />,
      title: "robotics",
      subtitle:
        "Another aspect that is part of the emerging definition of Web 3.0 is the notion of a semantic web. Among those that have advocated for the integration of semantic technology into the web is the creator of the web, Tim Berners-Lee.",
    },
    {
      id: 4,
      icon: <FaSatellite size={50} className="text-white" />,
      title: "payload to orbit",
      subtitle:
        "It took over 10 years to transition from the original web, Web 1.0, to Web 2.0, and it is expected to take just as long, if not longer, to fully implement and reshape the web with Web 3.0.",
    },
  ];

  return (
    <PageSection
      name="products"
      title="Products"
      subtitle={`Plainly lamplight whether evermore thereat tell, we or scarce bird spoken he whether on, sinking thy again sent what eyes tinkled his explore these. Within melancholy sad bird not respiterespite..`}
    >
      <div className="grid lg:grid-cols-2 gap-12 text-black">
        {products.map(({ id, icon, title, subtitle }) => (
          <div
            key={id}
            className="group bg-gradient-to-r from-thOrange to-thBlue rounded-lg flex flex-col items-center justify-center p-8 text-center"
          >
            <div className="flex items-center justify-center duration-300 group-hover:scale-110">
              <div className="bg-black rounded-full p-5 m-4">{icon}</div>
            </div>
            <h1 className="text-3xl lg:text-5xl my-8 capitalize">{title}</h1>
            <p className="text-lg">{subtitle}</p>
          </div>
        ))}
      </div>
    </PageSection>
  );
};

export default Prodcuts;
